module.exports = __webpack_public_path__ + "static/media/DIGITAL_INTERNALIZATION.194ca769.svg";